import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import selectSupplier from '@/components/selectSupplier'
import home from '@/components/home'
import hotel from '@/components/hotel'
import roomType from '@/components/roomType'
import order from '@/components/order'
import orderDetail from '@/components/orderDetail'
import OrderLinkEntry from '@/components/OrderLinkEntry'
import payRvDetailList from '@/components/payRvDetailList'
import { syncEmbedFlagFromRoute } from '@/utils/embed'
import { applyIncomingPlatformAuth } from '@/utils/ssoPlaceholder'
import { getToken } from '@/assets/js/auth'
import { getWechatOAuthCode, isWechatBrowser } from '@/utils/wechatOAuth'
import { savePendingOrderLink } from '@/utils/orderDeepLink'

const SUPPLIER_SELECT_KEY = 'ebooking_supplier_select'
const SUPPLIER_SWITCH_KEY = 'ebooking_supplier_switch'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/select-supplier',
      name: 'selectSupplier',
      component: selectSupplier
    },
    {
      path: '/order-link',
      name: 'orderLink',
      component: OrderLinkEntry
    },
    // 旧书签 /web 等形式若曾使用 /home，统一到带壳布局下的酒店列表
    { path: '/home', redirect: '/hotel' },
    {
      path: '/',
      component: home,
      redirect: '/hotel',
      children: [
        {
          path: 'hotel',
          name: 'hotel',
          meta: { embedFriendly: true },
          component: hotel
        },
        {
          path: 'roomType',
          name: 'roomType',
          meta: { embedFriendly: true },
          component: roomType
        },
        {
          path: 'payRvDetailList',
          name: 'payRvDetailList',
          meta: { embedFriendly: true },
          component: payRvDetailList
        },
        {
          path: 'order',
          name: 'order',
          meta: { embedFriendly: true },
          component: order
        },
        {
          path: 'orderDetail',
          name: 'orderDetail',
          meta: { embedFriendly: true },
          component: orderDetail
        }
      ]
    }
  ]
})

router.beforeEach(function (to, from, next) {
  syncEmbedFlagFromRoute(to)
  applyIncomingPlatformAuth(to)
  if (to.name === 'orderLink' && to.query && to.query.o_id && !getToken('userInfo')) {
    savePendingOrderLink(to)
  }
  if (isWechatBrowser() && getWechatOAuthCode() && to.path !== '/login') {
    next({ path: '/login', replace: true })
    return
  }
  const hasUser = !!getToken('userInfo')
  const onSelectPage = to.path === '/select-supplier'
  const onLoginPage = to.path === '/login'
  let hasSelectPending = false
  let isSupplierSwitch = false
  try {
    hasSelectPending = !!sessionStorage.getItem(SUPPLIER_SELECT_KEY)
    isSupplierSwitch =
      to.query.mode === 'switch' ||
      !!sessionStorage.getItem(SUPPLIER_SWITCH_KEY)
  } catch (e) {
    hasSelectPending = false
    isSupplierSwitch = to.query.mode === 'switch'
  }
  if (!hasUser && !onLoginPage && !onSelectPage) {
    next({ path: '/login', replace: true })
    return
  }
  if (!hasUser && hasSelectPending && !onSelectPage && !onLoginPage) {
    next({ path: '/select-supplier', replace: true })
    return
  }
  if (hasUser && onLoginPage) {
    next({ path: '/hotel', replace: true })
    return
  }
  if (hasUser && onSelectPage && !isSupplierSwitch) {
    next({ path: '/hotel', replace: true })
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js